import { isApiAccessEnabled } from 'routes/engage/api-access/constants';

export interface EngageSideNavigationVisibilityFlags {
  canManageGreetings: boolean;
  hasEngageApplications: boolean;
  canManageApi: boolean;
}

// Single source of truth for whether the Engage side navigation is available to the user
export const getIsEngageSideNavigationVisible = ({
  canManageGreetings,
  hasEngageApplications,
  canManageApi,
}: EngageSideNavigationVisibilityFlags): boolean =>
  canManageGreetings || hasEngageApplications || (canManageApi && isApiAccessEnabled());
